module.exports = __webpack_public_path__ + "static/media/occlusion_en.41a59203.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/occlusion_en.svg
// module id = 1074
// module chunks = 0